(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ryw-main-product"]) return;
  try {
    
  document.querySelectorAll('[data-duo-builder]').forEach((builder) => {
    const button = builder.querySelector('[data-duo-submit]');
    const status = builder.querySelector('[data-duo-status]');
    button.addEventListener('click', async () => {
      const candle = builder.querySelector('input[name="duo-candle"]:checked');
      const steamer = builder.querySelector('input[name="duo-steamer"]:checked');
      if (!candle || !steamer) { status.textContent = builder.dataset.choiceError; return; }
      button.disabled = true;
      status.textContent = builder.dataset.adding;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(candle.value), quantity: 1, properties: { Bundle: 'The Self Love Duo' } },
            { id: Number(steamer.value), quantity: 1, properties: { Bundle: 'The Self Love Duo' } }
          ] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(`${window.Shopify.routes.root}discount/SELFLOVEDUO?redirect=/cart`);
      } catch (error) { status.textContent = builder.dataset.cartError; button.disabled = false; }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
